<template>
    <div class="l-wrap">
        <div class="l-constrained l-content">
            <div class="modal" v-show="isConfirmResendDialogOpen" style="display: block" tabindex="-1" role="dialog" aria-hidden="true">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span></button>
                            <h4 class="modal-title" id="myModalLabel">
                                Are you sure, you want to resend {{applicationsToResend.length}} drivers.
                            </h4>
                        </div>
                        <div class="modal-footer" style="text-align: center">
                            <button type="button" class="btn" @click="isConfirmResendDialogOpen = false">No</button>
                            <button type="button" class="btn btn-primary" @click="onResendClicked" >Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <status-message v-model="statusMessage"></status-message>
                </div>
                <div class="row" style="margin-bottom: 20px">
                    <h4>Delivery</h4>
                    <div>
                        <span>{{deliveryText}}</span>
                        <span v-if="initialData.hasOtherDeliveries" class="label label-danger">
                            <span class="glyphicon glyphicon-warning-sign"></span> Some jobs override this setting
                        </span>
                    </div>

                </div>
                <div class="row">
                    <h2>Leads to resend</h2>
                    <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <tbody>
                            <tr>
                                <th>Date</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Zip Code</th>
                                <th>CDL XP</th>
                                <th></th>
                            </tr>
                            <tr v-for="app in applicationsToResend">
                                <td>
                                    {{ app.date }}
                                </td>
                                <td>{{ app.name }}</td>
                                <td>{{ app.type }}</td>
                                <td>{{ app.zip_code }}</td>
                                <td>{{ app.cdl_xp_text }}</td>
                                <td style="width: 80px; vertical-align: middle">
                                    <span class="glyphicon glyphicon-info-sign tooltip-clicks" style="top: 3px"
                                          data-toggle="tooltip" data-placement="top"
                                          :title="app.paid_media_source"></span>
                                    <div class="btn fas fa-trash" @click="onRemoveApplication(app)"></div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <h3 v-show="applicationsToResend.length == 0" style="text-align: center">
                            No Leads selected.
                        </h3>
                    </div>
                </div>
                <div class="row" style="text-align: right">
                    <button :disabled="applicationsToResend.length <= 0" class="btn btn-danger btn-lg" @click="isConfirmResendDialogOpen = true"
                            data-toggle="confirmation">
                        Resend <span v-show="applicationsToResend.length > 0" v-text="applicationsToResend.length"></span> Leads
                    </button>
                </div>
                <div class="row">
                    <h2 class="h5 h-aside">
                        Filters
                    </h2>
                    <div class="row">
                      <div class="form-group col-md-2">
                        <label for="dateFrom">From</label>
                        <input type="date" name="dateFrom" v-model="filterFromDate" class="form-control">
                      </div>
                      <div class="form-group col-md-2">
                        <label for="dateTo">To</label>
                        <input type="date" name="dateTo" v-model="filterToDate" class="form-control">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="byName">Name</label>
                        <input type="text" name="byName" v-model="filterByName" class="form-control">
                      </div>
                      <div class="form-group col-md-2">
                        <label for="isDelivered">Delivered?</label>
                        <select name="isDelivered" class="form-control" v-model="filterIsDelivered">
                          <option value="">...</option>
                          <option value="1">Delivered</option>
                          <option value="0">Failed</option>
                        </select>
                      </div>
                      <div class="form-group col-md-1" style="padding: 23px 0px 0 10px">
                        <button class="btn btn-info" @click="onApplyFilterClick">Apply</button>
                      </div>
                      <div class="form-group col-md-2" style="padding: 23px 20px 0 10px; text-align:right;">
                        <button class="btn btn-primary" @click="onAddAllApplications">Add all filtered leads</button>
                      </div>
                    </div>
                </div>
                <div class="row">
                    <h2>Employer's leads</h2>
                    <div class="table-responsive">
                        <table class="table table-striped table-hover">
                            <tbody>
                                <tr>
                                    <th>Date</th>
                                    <th>Name</th>
                                    <th>Type</th>
                                    <th>Zip Code</th>
                                    <th>CDL XP</th>
                                    <th></th>
                                </tr>
                                <tr v-for="app in filteredApplications" :key="`${app.id}-${app.job_id}`">
                                    <td>
                                        {{ app.date }}
                                    </td>
                                    <td>{{ app.name }}</td>
                                    <td>{{ app.type }}</td>
                                    <td>{{ app.zip_code }}</td>
                                    <td>{{ app.cdl_xp_text }}</td>
                                    <td style="width: 80px; vertical-align: middle">
                                        <span class="glyphicon glyphicon-info-sign tooltip-clicks" style="top: 3px"
                                              data-toggle="tooltip" data-placement="top"
                                              :title="app.paid_media_source"></span>
                                        <div class="btn fa fa-plus" @click="onAddApplication(app)"></div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <h3 v-show="filteredApplications.length == 0" style="text-align: center">
                            Sorry, no leads found.
                        </h3>
                    </div>
                </div>
            </div>
            <busy-spinner :is-on="isBusy"></busy-spinner>

            <employer-notes-wrapper :employer-id="employerId" />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            initialData: Object,
            employerId: { type: Number, required: true },
        },
        data() {
            return {
                applicationsToResend: [],
                filteredApplications: [],
                allApplications: [],
                filterFromDate: moment().subtract(1, "weeks").format('YYYY-MM-DD'),
                filterToDate: moment().format('YYYY-MM-DD'),
                filterByName: '',
                filterIsDelivered: '',
                isConfirmResendDialogOpen: false,
                isBusy: false
            };
        },
        computed: {
            getApplicationsUrl() {
                return url('admin/employer/' + this.initialData.employerId + '/get-applications');
            },
            resendApplicationsUrl() {
                return url('admin/employer/' + this.initialData.employerId + '/resend-applications');
            },
            deliveryText(){
                if(this.initialData.majorDelivery){
                    return this.initialData.majorDelivery
                }
                else{
                    return 'No jobs yet'
                }
            }
        },
        watch: {
            filterByName() {
                this.filterApplications(this.filterByName);
            }
        },
        methods: {
            onApplyFilterClick() {
                let params = {
                    from: this.filterFromDate,
                    to: this.filterToDate,
                    isDelivered: this.filterIsDelivered
                };
                this.makeGet(this.getApplicationsUrl, params,
                    (data) => {
                        this.allApplications = _.differenceBy(data, this.applicationsToResend, 'id');
                        this.filterApplications(this.filterByName);
                    },
                    () => {
                        this.showError("Connection with server failed");
                    });
            },
            onResendClicked() {
                this.isConfirmResendDialogOpen = false;
                let params = {
                    applicationsIds: _.map(this.applicationsToResend, (ms) => ms.id)
                };

                this.makePost(this.resendApplicationsUrl, params,
                    (data) => {
                        this.showSuccess("We're send the following drivers <br />" + data.join(', '));
                    },
                    () => {
                        this.showError("Connection with server failed");
                    });
            },
            onAddApplication(app) {
                this.applicationsToResend.push(app);
                _.remove(this.allApplications, app);
                this.applicationsToResend = _.sortBy(this.applicationsToResend, 'date', 'desc');
                this.filterApplications(this.filterByName);
            },
            onAddAllApplications() {
                this.applicationsToResend = _.concat(this.applicationsToResend, this.filteredApplications);
                _.pullAllBy(this.allApplications, this.filteredApplications, 'id');
                this.applicationsToResend = _.sortBy(this.applicationsToResend, 'date', 'desc');
                this.filterApplications(this.filterByName);
            },
            onRemoveApplication(ms) {
                this.allApplications.push(ms);
                _.remove(this.applicationsToResend, ms);
                this.allApplications = _.sortBy(this.allApplications, 'date', 'desc');
                this.filterApplications(this.filterByName);
            },
            filterApplications(name) {
                if (name.trim() === '') {
                    this.filteredApplications = _.cloneDeep(this.allApplications);
                    return;
                }
                name = name.toLowerCase();
                this.filteredApplications = _.filter(this.allApplications, (app) => {
                    let appName = app.name.toLowerCase();
                    return appName.includes(name);
                });
            }

        },
        updated: function () {
            $('[data-toggle="tooltip"]').tooltip();
        },
        mounted: function () {
            this.onApplyFilterClick();
            this.sendToEmail = this.initialData.employerEmail;

        }
    }

</script>
